@let currentUser = this.currentUser();
@let currentUserName = this.currentUserName();
@let adminLabel = this.adminLabel();

<div class="container">
  <header class="header">
    <h1 class="header-logo">
      <span>VI.BE</span>
    </h1>
    <button
      type="button"
      title="Sluiten"
      i18n-title
      class="header-closeButton"
      (click)="menuClosed.emit()"
    >
      <i class="header-closeButton-icon fal fa-times"></i>
    </button>
  </header>

  <section class="content" [class.content--custom]="contentMenu?.length">
    <!-- Platform -->
    <ul class="menu">
      <!-- Default -->
      @if (!contentMenu?.length) {
        <li class="menu-item">
          <a
            routerLink="/"
            class="menu-item-main"
            routerLinkActive="menu-item-main--active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="menuClosed.emit()"
            ><span class="menu-item-text" i18n>Home</span></a
          >
        </li>
        <li class="menu-item">
          <a
            routerLink="/calls"
            class="menu-item-main"
            routerLinkActive="menu-item-main--active"
            (click)="menuClosed.emit()"
            ><span class="menu-item-text" i18n>Kansen</span></a
          >
        </li>
        <li class="menu-item">
          <a
            routerLink="/artists"
            class="menu-item-main"
            routerLinkActive="menu-item-main--active"
            (click)="menuClosed.emit()"
            ><span class="menu-item-text" i18n>Artiesten</span></a
          >
        </li>
        @if (!currentUser) {
          <li class="menu-item">
            <a
              class="menu-item-main"
              routerLink="/auth/signin"
              routerLinkActive="menu-item-active"
              (click)="menuClosed.emit()"
              ><span class="menu-item-text" i18n>Log in</span></a
            >
          </li>
          <li class="menu-item">
            <a
              class="menu-item-main"
              routerLink="/auth/signup"
              routerLinkActive="menu-item-main--active"
              (click)="menuClosed.emit()"
              ><span class="menu-item-text" i18n>Registreer</span></a
            >
          </li>
        }
        @if (currentUser) {
          @if (
            currentUser?.roles?.includes("ADMIN") ||
            currentUser?.roles?.includes("REGION_ADMIN")
          ) {
            <li class="menu-item">
              <a
                routerLink="/admin"
                class="menu-item-main"
                routerLinkActive="menu-item-main--active"
                (click)="menuClosed.emit()"
                ><span class="menu-item-text">{{ adminLabel }}</span></a
              >
            </li>
          }
          <!-- Account -->
          <li class="menu-user menu-item">
            <button
              class="menu-item-main--preserveCasing menu-item-main--hasIcon"
              [class.menu-item-main--open]="menuItemsOpen.includes('user')"
              (click)="toggleMenuItem('user')"
            >
              <div
                class="user"
                [title]="currentUserName + ' ' + currentUser.email"
              >
                <app-avatar
                  [user]="currentUser"
                  [light]="true"
                  class="user-avatar"
                ></app-avatar>
                <p class="user-name menu-item-text">
                  {{ currentUser.givenName }}
                </p>
              </div>
              <i class="menu-item-chevron fal fa-chevron-down"></i>
            </button>
            <ul class="submenu">
              <li class="submenu-item">
                <a
                  routerLink="/auth/account"
                  class="submenu-item-main"
                  routerLinkActive="submenu-item-main--active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="menuClosed.emit()"
                  ><span class="menu-item-text" i18n>Account</span></a
                >
              </li>
              <li class="submenu-item">
                <a
                  routerLink="/auth/account/playlists"
                  class="submenu-item-main"
                  routerLinkActive="submenu-item-main--active"
                  (click)="menuClosed.emit()"
                  ><span class="menu-item-text" i18n>Playlists</span></a
                >
              </li>
              <li class="submenu-item">
                <a
                  routerLink="/auth/account/profiles"
                  class="submenu-item-main"
                  routerLinkActive="submenu-item-main--active"
                  (click)="menuClosed.emit()"
                  ><span class="menu-item-text" i18n>Profielen</span></a
                >
              </li>
              <ng-template [ngTemplateOutlet]="artistProfiles"></ng-template>
              <ng-template
                [ngTemplateOutlet]="organisationProfiles"
              ></ng-template>
              @if (
                (
                  currentUser?.invites?.items
                  | userInvited: "ORGANISATION_CALL" : true
                )?.length ||
                currentUser?.acceptedOrganisationCalls?.items?.length
              ) {
                <li class="submenu-item">
                  <span class="submenu-item-main" i18n>Kansen</span>
                </li>
                <ng-template [ngTemplateOutlet]="pendingCalls"></ng-template>
                <ng-template [ngTemplateOutlet]="acceptedCalls"></ng-template>
              }
            </ul>
          </li>
          <!-- Sign out -->
          <li class="menu-item">
            <button class="menu-item-main" (click)="signout()" i18n>
              Uitloggen
            </button>
          </li>
        }
      }

      <!-- Custom -->
      @if (contentMenu?.length) {
        <li
          class="menu-item"
          [style.--menu-item-position]="menuPlatformPosition"
        >
          <button
            (click)="toggleMenuItem('platform')"
            class="menu-item-main menu-item-main--active menu-item-main--hasIcon"
            [class.menu-item-main--open]="menuItemsOpen.includes('platform')"
          >
            <span class="menu-item-text" i18n>Platform</span>
            <i class="menu-item-chevron fal fa-chevron-down"></i>
          </button>
          <ul class="submenu">
            <li class="submenu-item">
              <a
                routerLink="/calls"
                class="submenu-item-main"
                routerLinkActive="submenu-item-main--active"
                (click)="menuClosed.emit()"
                i18n
                >Kansen</a
              >
            </li>
            <li class="submenu-item">
              <a
                routerLink="/artists"
                class="submenu-item-main"
                routerLinkActive="submenu-item-main--active"
                (click)="menuClosed.emit()"
                i18n
                >Artiesten</a
              >
            </li>
            <li class="submenu-item">
              <a
                routerLink="/"
                class="submenu-item-main"
                routerLinkActive="submenu-item-main--active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="menuClosed.emit()"
                i18n
              >
                About</a
              >
            </li>
            <!-- Current user -->
            @if (currentUser) {
              <!-- Admin -->
              @if (
                currentUser?.roles?.includes("ADMIN") ||
                currentUser?.roles?.includes("REGION_ADMIN")
              ) {
                <li class="submenu-item">
                  <a
                    routerLink="/admin"
                    class="submenu-item-main"
                    routerLinkActive="submenu-item-main--active"
                    (click)="menuClosed.emit()"
                    >{{ adminLabel }}</a
                  >
                </li>
              }
              <!-- Account -->
              <li class="menu-user submenu-item">
                <a
                  class="submenu-item-main--preserveCasing"
                  routerLink="/auth/account"
                  routerLinkActive="submenu-item-main--active"
                  (click)="menuClosed.emit()"
                >
                  <div
                    class="user"
                    [title]="currentUserName + ' ' + currentUser.email"
                  >
                    <app-avatar
                      [user]="currentUser"
                      [light]="true"
                      class="user-avatar"
                    ></app-avatar>
                    <p class="user-name">{{ currentUser.givenName }}</p>
                  </div>
                </a>
              </li>
              <ng-template [ngTemplateOutlet]="artistProfiles"></ng-template>
              <ng-template
                [ngTemplateOutlet]="organisationProfiles"
              ></ng-template>
              <ng-template [ngTemplateOutlet]="pendingCalls"></ng-template>
              <ng-template [ngTemplateOutlet]="acceptedCalls"></ng-template>
              <!-- Sign out -->
              <li class="submenu-item">
                <button class="submenu-item-main" (click)="signout()" i18n>
                  Uitloggen
                </button>
              </li>
            }
            <!-- Login / Register -->
            @if (!currentUser) {
              <li class="submenu-item">
                <a
                  class="submenu-item-main"
                  routerLink="/auth/signin"
                  routerLinkActive="submenu-item-active"
                  (click)="menuClosed.emit()"
                  i18n
                  >Log in</a
                >
              </li>
              <li class="submenu-item">
                <a
                  class="submenu-item-main"
                  routerLink="/auth/signup"
                  routerLinkActive="submenu-item-main--active"
                  (click)="menuClosed.emit()"
                  i18n
                  >Registreer</a
                >
              </li>
            }
          </ul>
        </li>
        <!-- Editorial -->
        @for (item of contentMenu; track item; let i = $index) {
          <li class="menu-item" [style.--menu-item-position]="i + 1">
            @if (item.routerLink) {
              <a
                [routerLink]="item.routerLink || null"
                [routerLinkActive]="'menu-item-main--active'"
                class="menu-item-main--preserveCasing menu-item-main--hasIcon"
                ><span class="menu-item-text"> {{ item.label }} </span>
                @if (item.submenu?.length) {
                  <i class="menu-item-chevron fal fa-chevron-down"></i>
                }
              </a>
            }
            @if (item.link && !item.routerLink) {
              <a
                [href]="item.link"
                class="menu-item-main--preserveCasing menu-item-main--hasIcon"
                ><span class="menu-item-text"> {{ item.label }} </span>
                @if (item.submenu?.length) {
                  <i class="menu-item-chevron fal fa-chevron-down"></i>
                }
              </a>
            }
            @if (!item.routerLink && !item.link) {
              <button
                (click)="toggleMenuItem(item.label)"
                class="menu-item-main menu-item-main--preserveCasing menu-item-main--hasIcon"
                [class.menu-item-main--open]="
                  menuItemsOpen.includes(item.label)
                "
              >
                <span class="menu-item-text"> {{ item.label }} </span>
                @if (item.submenu?.length) {
                  <i class="menu-item-chevron fal fa-chevron-down"></i>
                }
              </button>
            }
            @if (item.submenu?.length) {
              <ul class="submenu">
                @for (submenuItem of item.submenu; track submenuItem) {
                  <li class="submenu-item">
                    @if (submenuItem.routerLink) {
                      <a
                        [routerLink]="submenuItem.routerLink || null"
                        [routerLinkActive]="'submenu-item-main--active'"
                        [routerLinkActiveOptions]="{
                          exact: submenuItem.routerLink === '/',
                        }"
                        class="submenu-item-main--preserveCasing"
                        >{{ submenuItem.label }}</a
                      >
                    }
                    @if (submenuItem.link && !submenuItem.routerLink) {
                      <a
                        [href]="submenuItem.link"
                        class="submenu-item-main--preserveCasing"
                        >{{ submenuItem.label }}</a
                      >
                    }
                    @if (!submenuItem.routerLink && !submenuItem.link) {
                      <span class="submenu-item-main--preserveCasing">{{
                        submenuItem.label
                      }}</span>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      }
    </ul>

    <footer class="footer">
      @for (list of contentFooter?.lists; track list) {
        <ul class="footer-list">
          @for (item of list; track item) {
            <li class="footer-list-li">
              @if (item.link) {
                <a
                  href="{{ item.link }}"
                  [attr.target]="item.target || null"
                  rel="noopener"
                  >{{ item.label }}
                </a>
              }
              @if (item.routerLink) {
                <a [routerLink]="item.routerLink" (click)="menuClosed.emit()">{{
                  item.label
                }}</a>
              }
              @if (!(item.link || item.routerLink)) {
                <span>{{ item.label }}</span>
              }
            </li>
          }
        </ul>
      }
    </footer>
  </section>

  @if (contentImage) {
    <img class="image" src="{{ contentImage }}" loading="lazy" />
  }
</div>

<ng-template #artistProfiles>
  @for (
    invite of currentUser?.invites?.items | userInvited: "ARTIST";
    track invite
  ) {
    <li class="submenu-item">
      <a
        class="submenu-item-main--preserveCasing menu-item-main--hasIcon"
        routerLink="/{{ invite.inviteOwner.slug }}"
        routerLinkActive="submenu-item-main--active"
        (click)="menuClosed.emit()"
      >
        <i class="submenu-item-icon {{ brandedIcons.listItem }}"></i>
        <span class="submenu-item-text">{{ invite.inviteOwner.name }}</span>
        @if (invite.currentState.state === "PENDING") {
          <span
            class="submenu-item-badge"
            title="Je bent uitgenodigd"
            i18n-title
          ></span>
        }
      </a>
    </li>
  }
</ng-template>

<ng-template #organisationProfiles>
  @for (
    invite of currentUser?.invites?.items | userInvited: "ORGANISATION";
    track invite
  ) {
    <li class="submenu-item">
      <a
        class="submenu-item-main--preserveCasing menu-item-main--hasIcon"
        routerLink="/{{ invite.inviteOwner.slug }}"
        routerLinkActive="submenu-item-main--active"
        (click)="menuClosed.emit()"
      >
        <i class="submenu-item-icon {{ brandedIcons.listItem }}"></i>
        <span class="submenu-item-text">{{ invite.inviteOwner.name }}</span>
        @if (invite.currentState.state === "PENDING") {
          <span class="submenu-item-badge" title="Je bent uitgenodigd"></span>
        }
      </a>
    </li>
  }
</ng-template>

<ng-template #pendingCalls>
  @for (
    invite of currentUser?.invites?.items
      | userInvited: "ORGANISATION_CALL" : true
      | orderBy: "asc" : "datePublished";
    track invite
  ) {
    <li class="submenu-item">
      <a
        class="submenu-item-main--preserveCasing menu-item-main--hasIcon"
        routerLink="/{{ invite.inviteOwner.organisationSlug }}/calls/{{
          invite.inviteOwner.slug
        }}"
        routerLinkActive="submenu-item-main--active"
        (click)="menuClosed.emit()"
        title="{{ invite.inviteOwner.title }}"
      >
        <i class="submenu-item-icon {{ brandedIcons.listItem }}"></i>
        <span class="submenu-item-text">{{ invite.inviteOwner.title }}</span>
        <span
          class="submenu-item-badge"
          title="Je bent uitgenodigd"
          i18n-title
        ></span>
      </a>
    </li>
  }
</ng-template>

<ng-template #acceptedCalls>
  @for (
    organisationCall of currentUser?.acceptedOrganisationCalls?.items
      | slice: 0 : numberOfAcceptedOrganisationCallsInMenu;
    track organisationCall
  ) {
    <li class="submenu-item">
      <a
        class="submenu-item-main--preserveCasing menu-item-main--hasIcon"
        routerLink="/{{ organisationCall.organisation.slug }}/calls/{{
          organisationCall.slug
        }}"
        routerLinkActive="submenu-item-main--active"
        (click)="menuClosed.emit()"
        title="{{ organisationCall.title }}"
      >
        <i class="submenu-item-icon {{ brandedIcons.listItem }}"></i>
        <span class="submenu-item-text">{{ organisationCall.title }}</span>
      </a>
    </li>
  }
</ng-template>
